var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "18px",
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3306C4A1-9FF2-4BCE-80FF-4C1C46DB3C60") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-3-3---Actioning-an-Alert",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3-3-2---Actioning-an-Alert",
    transform: "translate(-485.000000, -38.000000)",
    fill: "#081981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.-Icons/ic_search",
    transform: "translate(485.000000, 38.863636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.07142856,0.0758928325 C9.38267152,0.0758928325 12.0669643,2.76018561 12.0669643,6.07142856 C12.0669643,7.53587297 11.5419229,8.87768738 10.6698122,9.9188996 L16.6592219,15.907921 C16.866688,16.115387 16.866688,16.4517559 16.6592219,16.6592219 C16.4677148,16.850729 16.1663733,16.8654604 15.9579686,16.7034159 L15.907921,16.6592219 L9.9188996,10.6698122 C8.87768738,11.5419229 7.53587297,12.0669643 6.07142856,12.0669643 C2.76018561,12.0669643 0.0758928325,9.38267152 0.0758928325,6.07142856 C0.0758928325,2.76018561 2.76018561,0.0758928325 6.07142856,0.0758928325 Z M6.07142856,1.13839283 C3.34698816,1.13839283 1.13839283,3.34698816 1.13839283,6.07142856 C1.13839283,8.79586897 3.34698816,11.0044643 6.07142856,11.0044643 C8.79586897,11.0044643 11.0044643,8.79586897 11.0044643,6.07142856 C11.0044643,3.34698816 8.79586897,1.13839283 6.07142856,1.13839283 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.a83586ef2f86e9c1637c1ef0bf53d4ad.svg";
export { ForwardRef as ReactComponent };